// eslint-disable-next-line import/prefer-default-export
export function getBrandedAssetUrl(state, controller, name, unwrapped) {
    let size = 'd';

    if (state.options.isKiosk) {
        size = 'k';
    } else if (window.innerWidth < 1024) {
        size = 'm';
    } else {
        size = 'd';
    }

    const assetName = `fun-${name}-asset`.replace('{size}', size);

    if (controller && controller.blueprint && controller.blueprint.custom) {
        const asset = controller.blueprint.custom[assetName];

        if (asset) {
            if (asset.startsWith('https:') || asset.startsWith('//')) {
                return asset;
            }

            const root = controller.blueprint.imageRootUrl;

            if (unwrapped) {
                return `${root}${asset}`;
            }

            return `url("${root}${asset}")`;
        }
    }

    return '';
}

export function getAssetUrl(controller, name, unwrapped) {
    if (controller && controller.blueprint && controller.blueprint.custom) {
        const asset = controller.blueprint.custom[name];

        if (asset) {
            if (asset.startsWith('https:') || asset.startsWith('//')) {
                return asset;
            }

            const root = controller.blueprint.imageRootUrl;

            if (unwrapped) {
                return `${root}${asset}`;
            }

            return `url("${root}${asset}")`;
        }
    }

    return '';
}
